import React from "react";
import ReactDOM from "react-dom";
import App from './App';

import './styles/custom.scss';

const root = document.getElementById("haAnalyzer");
const loggedIn = root.getAttribute("logged_in");
const userStatus = root.getAttribute("user_status");
const ajax_url = root.getAttribute("ajax_url");
const post_text = root.getAttribute("post_text");
// const ssoFlag = document.getElementById("jsSSOLoginFlag").value;

function HeadlineAnalyzer() {
  return (
    <App loggedIn={loggedIn} userStatus={userStatus} ajax_url={ajax_url} post_text={post_text}/>
  );
}

ReactDOM.render(<HeadlineAnalyzer/>, root);
